import { OptimizerResultsState } from "../OptimizerResultsState";

export class ThermalBridgesOptimizer {
  constructor(
    isInReferenceState,
    dictionary,
    buildingType,
    refPricePerKWh,
    newPricePerKWh
  ) {
    this.elementList = dictionary;
    this.buildingType = buildingType;
    this.refPricePerKWh = refPricePerKWh;
    this.newPricePerKWh = newPricePerKWh;
    this.isInReferenceState = isInReferenceState;
  }
  elementList;

  validate = (
    type,
    result,
    element,
    newElement,
    surface,
    refCosts,
    newCosts
  ) => {
    result.state = OptimizerResultsState.THE_SAME;

    result.refItem = this.elementList.filter(
      item => item.id === element.thermalBridgesType.id
    )[0];
    result.newItem = this.elementList.filter(
      item => item.id === newElement.thermalBridgesType.id
    )[0];
    result.obsolescence = result.newItem.obsolescence;
    result.service = 0;

    const surfaceMB = Math.sqrt(surface) * 6;

    if (
      element.thermalBridgesType.uValue < newElement.thermalBridgesType.uValue
    ) {
      result.state = OptimizerResultsState.WORSE;
    } else if (
      element.thermalBridgesType.uValue > newElement.thermalBridgesType.uValue
    ) {
      result.state = OptimizerResultsState.BETTER;
      result.refPricePerKWh = this.refPricePerKWh;
      result.newPricePerKWh = this.newPricePerKWh;

      let materialCost = result.refItem.price;
      let newMaterialCost = result.newItem.price;
      let workCost = result.refItem.work;
      let newWorkCost = result.newItem.work;

      if (refCosts[type + "_material_changed"]) {
        materialCost = refCosts[type + "_material"];
      }
      if (newCosts[type + "_material_changed"]) {
        newMaterialCost = newCosts[type + "_material"];
      }
      if (refCosts[type + "_work_changed"]) {
        workCost = refCosts[type + "_work"];
      }
      if (newCosts[type + "_work_changed"]) {
        newWorkCost = newCosts[type + "_work"];
      }

      result.work =
        this.buildingType === "current"
          ? this.calculateWork(newWorkCost, surfaceMB)
          : 0;
      result.material =
        this.buildingType === "current"
          ? this.calculateMaterial(newMaterialCost, surfaceMB)
          : this.calculateMaterialDifference(
              materialCost,
              newMaterialCost,
              surfaceMB
            );
      result.obsolescence = result.newItem.obsolescence;
      result.cost = result.work + result.material;
      result.workPrice = this.isInReferenceState ? workCost : newWorkCost;
      result.materialPrice = this.isInReferenceState
        ? materialCost
        : newMaterialCost;
      result.costView = result.workPrice + result.materialPrice * surfaceMB;
    }

    return result;
  };

  calculateMaterial = (price, surface) => {
    return price * surface;
  };

  calculateMaterialDifference = (price, newPrice, surface) => {
    return (newPrice - price) * surface;
  };

  calculateWork = (work, surface) => {
    return work * surface;
  };

  calculateWorkDifference = (work, newWork, surface) => {
    return (newWork - work) * surface;
  };
}
